<template>
    <div> 
      Welcome to the terminal management panel
    </div>
  </template>
  
  <script>
  export default {
    name: 'terminalDashboard',
    data () {
      return {
  
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/dashboard/terminal.vue